export default __webpack_public_path__ + "static/media/427.b9ed92ed.png";